  export const capitalizeFirstLetter = (str) => {
      if (str && str.length > 0) {
          return str.charAt(0).toUpperCase() + str.slice(1);
        }
        return str;
  }
  export const lowerFirstLetter = (str) => {
      if (str && str.length > 0) {
          return str.charAt(0).toLowerCase() + str.slice(1);
        }
        return str;
  }
  export function encodeValueForUrl(value) {
      let stringValue;
      if (Array.isArray(value)) {
          stringValue = value.join(',');
      } else {
          stringValue = String(value);
      }
      return btoa(encodeURIComponent(stringValue));
  }
  export function decodeValueFromUrl(encodedString) {
      try {
          return decodeURIComponent(atob(encodedString));
      } catch (e) {
          console.error("Error decoding URL value:", e);
          return '';
      }
  }
  export function parseCommaSeparatedString(str) {
      if (typeof str === 'string' && str.length > 0) {
          return str.split(',');
      }
      return [];
  }

  export function camelToUpperWords(str) {
    if (!str) return '';

    return str
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .toUpperCase();
}
  export default class Helper {
      static validatePassword(password) {
          return new RegExp(
            "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
          ).test(password); // eslint-disable-line
      }
  }

export async function captureScreenshot(element = document.body, options = {}) {
  const defaultOptions = {
    scale: 0.8,
    useCORS: true,
    allowTaint: true,
    logging: false,
    backgroundColor: '#ffffff'
  };

  try {
    const { default: html2canvas } = await import('html2canvas');
    const canvas = await html2canvas(element, { ...defaultOptions, ...options });
    return canvas.toDataURL('image/jpeg', 0.6);
  } catch (error) {
    console.warn('Screenshot capture failed:', error);
    return null;
  }
}

export async function withScreenshot(apiCall, element = document.body) {
  try {
    const screenshot = await captureScreenshot(element);
    return await apiCall(screenshot);
  } catch (error) {
    console.warn('Error in withScreenshot:', error);
    // Continue with the API call even if screenshot fails
    return await apiCall(null);
  }
}
  